module.exports = "<div class=\"schedule-tile\">\n  <div class=\"title\"></div>\n  <div class=\"description\">\n    {{item | scheduleTitle}}\n  </div>\n  <div class=\"icons\">\n    <div class=\"devices\">\n      <i class=\"fa fa-fw fa-clock-o\"></i>\n      <i [ngClass]=\"ci.iconClass\" *ngFor=\"let ci of item.codeItems\"></i>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/schedule-tile/schedule-tile.component.html
// module id = 1539
// module chunks = 2